import { render, staticRenderFns } from "./Expertise.vue?vue&type=template&id=73a70738&scoped=true&"
import script from "./Expertise.vue?vue&type=script&lang=js&"
export * from "./Expertise.vue?vue&type=script&lang=js&"
import style0 from "./Expertise.vue?vue&type=style&index=0&id=73a70738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a70738",
  null
  
)

export default component.exports